/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import StyledImage from '@apps/components/Image';
import { LightboxImage } from '@apps/components/Lightbox';
import ZoonIconWrapper from '@apps/components/ZoonIconWrapper';
import { Stack, Typography } from '@mui/material';
import { BorderTitle } from '@stack/ui/components';
import { StaticImageData } from 'next/image';

export type CarDimensionBoxProps = {
  car_dimension_image_full: string | StaticImageData;
  carTitle?: string;
  //
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarDimensionBox: React.FC<CarDimensionBoxProps> = (props) => {
  const { car_dimension_image_full, carTitle } = props;

  const [open, setOpen] = useState(false);

  const onHandleClose = () => {
    setOpen(false);
  };

  const onHandleOpen = () => {
    setOpen(true);
  };

  const isEmptyData = !car_dimension_image_full;

  // ======================= VIEWS
  const renderCarDimensionContent = () => {
    if (isEmptyData) {
      return (
        <Stack
          position={'relative'}
          justifyContent={'center'}
          border={'1px solid #EDECED'}
          sx={{ marginTop: 5, minHeight: 164 }}
        >
          <Typography textAlign={'center'} fontSize={16} fontWeight={400}>
            No Dimension Found.
          </Typography>
        </Stack>
      );
    }
    return (
      <Stack
        position={'relative'}
        justifyContent={'center'}
        border={'1px solid #EDECED'}
        sx={{ marginTop: 5 }}
      >
        <ZoonIconWrapper onZoon={onHandleOpen}>
          <StyledImage
            src={car_dimension_image_full as string}
            alt={carTitle}
            loading={'lazy'}
            fetchPriority={'auto'}
            priority={false}
            width={300}
            height={200}
          />
        </ZoonIconWrapper>
        <LightboxImage
          source={{
            alt: carTitle,
            src: car_dimension_image_full as string,
          }}
          open={open}
          onClose={onHandleClose}
        />
      </Stack>
    );
  };
  return (
    <div>
      <BorderTitle title={'Dimension'} />
      {renderCarDimensionContent()}
    </div>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default CarDimensionBox;
